import * as ZapparThree from '@zappar/zappar-threejs'

import { useEffect, useState } from 'react'

import Analytics from '../analytics'

const CAMERA_ACCESS = 'camera_access'

/**
 * Camera permission request state
 */
const useCameraPermimssion = () => {
  const [granted, setGranted] = useState(false) // allow camera to be used
  const [hasAccess, setAccess] = useState(false) // track camera granted status to avoid to trigger all the time the accept camera event

  useEffect(() => {
    const camAccessStatus = localStorage?.getItem(CAMERA_ACCESS)
    if (camAccessStatus === 'allowed') setAccess(true)
    else localStorage?.setItem(CAMERA_ACCESS, 'allowed')
  }, [])

  const zapparPermissionRequest = async () => {
    const granted = await ZapparThree.permissionRequestUI()

    if (granted) {
      if (!hasAccess) Analytics.event.camera_access_click('Allowed')
      setGranted(true)
    } else {
      Analytics.event.camera_access_click('Denied')
      ZapparThree.permissionDeniedUI()
    }
  }

  return { granted, zapparPermissionRequest }
}

export default useCameraPermimssion
